module.exports = __webpack_public_path__ + "static/media/4 3 tattoo forearm portrait raven valkyrie intense cinematic.1280x1706.af25de95.webp";